import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NetworkDto } from '@cradua/data';
import Swal from 'sweetalert2';

@Component({
  selector: 'cradua-network',
  templateUrl: './network.component.html',
  styleUrls: ['./network.component.css']
})
export class NetworkComponent implements OnChanges {


  networkForm: FormGroup;
  networkFormArray: FormGroup;
  control = new FormControl();
  @Input() networks: NetworkDto[];
  @Input() routeAnimationsElements: any;
  @Output() network = new EventEmitter<NetworkDto[]>()
  @Output() deleteNetworkEvent = new EventEmitter<any>()

    selectedNetwork: any;
    filteredDelete: Array<any> =[];
    loading = true;
    selectedIndex = null;
    constructor(
     private fb: FormBuilder,
     ) {}

    ngOnChanges() {
      this.createNetworkForm();
    }

    createNetworkForm() {
      this.networkForm = this.fb.group({
        NetworkName: ['', Validators.required],
      
        id: null
        });
        this.networkFormArray = this.fb.group({ Networks: this.fb.array([])
          });
        this.setNetwork();
    }

  // method to display networks
  setNetwork() {
    const control  = this.networkFormArray.controls.Networks as FormArray;
    this.networks.forEach( e => {
      control.push(
        this.fb.group({
          NetworkName: e.NetworkName,
         
          id: e.id
        })
      );
    });
  }


  // method to add Network
  addNetwork(value: NetworkDto) {
    const control  = this.networkFormArray.controls.Networks as FormArray;
    control.insert(0,
          this.fb.group({
            NetworkName: value.NetworkName,
           
            id: null
          })
       );
  }

  selectNetwork(value) {}

  // method to delete network from arrary list
  deleteNetwork(index, value) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You will not be able to recover this imaginary file!',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.value) {
  const control = this.networkFormArray.controls.Networks as FormArray;
  control.removeAt(index);
  for ( let i = 0; i < this.networks.length; i++) {
      if (i === index) {
        if (value.id !== null) {
          this.filteredDelete.push(this.networks[i].id);
         }

      }
    }
  Swal.fire(
          'Deleted!',
          'Your imaginary file has been deleted.',
          'success'
        );
      } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.fire(
            'Cancelled',
            'Your imaginary file is safe :)',
            'error'
          );
        }
      });
  }

  addNew(formValue: NetworkDto) {
    if(this.networkForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    if(this.selectedIndex != null) {

      this.networkFormArray.get('Networks')['controls'][this.selectedIndex].patchValue({NetworkName: formValue.NetworkName});
    } else {
      this.addNetwork(formValue);
    }
    this.selectedIndex = null;
    this.networkForm.reset()
  }

  onEdit(index, value: NetworkDto) {
    console.log(index, value)
    this.selectedIndex = index;
    this.networkForm.patchValue({NetworkName: value.NetworkName});
   
  }

  onClearForm() {
    this.selectedIndex = null;
    this.networkForm.reset();
  }

  onSubmit(formValue: NetworkDto[]) {
  this.network.emit(formValue);
  if(this.filteredDelete.length !== 0) {
    this.deleteNetworkEvent.emit(this.filteredDelete);
  }
  }

}
